import React from "react";
import { useIntl } from "react-intl";

const ListUsersSessionVisitor: React.FC = () => {
  const intl = useIntl();

  return (
    <div className="row m-0 p-0 table-responsive">
      <div className="col card text-center justify-content-center align-items-center table-responsive w-100">
        <label className="fw-bold text-hover-primary fs-1 pb-5 pt-5">
          {intl.formatMessage({
            id: "MENU.DASHBOARD_PLANS_SALES.PLANS",
          })}
          /
          {intl.formatMessage({
            id: "MENU.DASHBOARD_PLANS_SALES.VISITOR",
          })}
        </label>
        <table className="table table-striped">
          <thead className="text-center border-bottom border-white">
            <tr>
              <th scope="col">
                <div>
                  <h3 className="fw-bold text-hover-primary fs-12">
                    {intl.formatMessage({
                      id: "MENU.DASHBOARD_PLANS_SALES.PHOTO",
                    })}
                  </h3>
                </div>
              </th>
              <th scope="col">
                <div>
                  <h3 className="fw-bold text-hover-primary fs-12">
                    {intl.formatMessage({
                      id: "MENU.DASHBOARD_PLANS_SALES.NAME",
                    })}
                  </h3>
                </div>
              </th>
              <th scope="col">
                <div>
                  <h3 className="fw-bold text-hover-primary fs-12">
                    {" "}
                    {intl.formatMessage({
                      id: "MENU.DASHBOARD_PLANS_SALES.PLANS",
                    })}
                  </h3>
                </div>
              </th>
              <th scope="col">
                <div>
                  <h3 className="fw-bold text-hover-primary fs-12">
                    {intl.formatMessage({
                      id: "MENU.DASHBOARD_PLANS_SALES.VALUE",
                    })}
                  </h3>
                </div>
              </th>
              <th scope="col">
                <div>
                  <h3 className="fw-bold text-hover-primary fs-12">
                    {" "}
                    {intl.formatMessage({
                      id: "MENU.DASHBOARD_PLANS_SALES.SITUATION",
                    })}
                  </h3>
                </div>
              </th>
              <th scope="col">
                <div>
                  <h3 className="fw-bold text-hover-primary fs-5">
                    {intl.formatMessage({
                      id: "MENU.DASHBOARD_PLANS_SALES.QTD_ACCESS",
                    })}
                  </h3>
                </div>
              </th>
              <th scope="col">
                <div>
                  <h3 className="fw-bold text-hover-primary fs-12">
                    {intl.formatMessage({
                      id: "MENU.DASHBOARD_PLANS_SALES.LAST_ACESS",
                    })}
                  </h3>
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="text-center justify-content-center align-items-center align-baseline">
            <tr>
              <td>
                <span className="svg-icon svg-icon-danger">
                  <img
                    id="imgUsersStudent"
                    className="w-40px"
                    src="/media/avatars/300-7.jpg"
                    alt="users"
                  />
                </span>
              </td>
              <td>
                <div>
                  <p className="fw-bold text-hover-primary fs-6">Rodrigo</p>
                </div>
              </td>
              <td>
                <div>
                  <p className="fw-bold text-hover-primary fs-6">Estudante</p>
                </div>
              </td>
              <td>
                <div>
                  <p className="fw-bold text-hover-primary fs-6">R$ 350,00</p>
                </div>
              </td>
              <td>
                <div>
                  <p className="fw-bold text-hover-primary fs-6">Pendente</p>
                </div>
              </td>
              <td>
                <div>
                  <p className="fw-bold text-hover-primary fs-6">58</p>
                </div>
              </td>
              <td>
                <div>
                  <p className="fw-bold text-hover-primary fs-6">
                    2{" "}
                    {intl.formatMessage({
                      id: "MENU.DASHBOARD_PLANS_SALES.DAYS",
                    })}
                  </p>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <span className="svg-icon svg-icon-danger">
                  <img
                    id="imgUsersStudent"
                    className="w-40px"
                    src="/media/avatars/300-7.jpg"
                    alt="users"
                  />
                </span>
              </td>
              <td>
                <div>
                  <p className="fw-bold text-hover-primary fs-6">Rodrigo</p>
                </div>
              </td>
              <td>
                <div>
                  <p className="fw-bold text-hover-primary fs-6">Estudante</p>
                </div>
              </td>
              <td>
                <div>
                  <p className="fw-bold text-hover-primary fs-6">R$ 350,00</p>
                </div>
              </td>
              <td>
                <div>
                  <p className="fw-bold text-hover-primary fs-6">
                    {intl.formatMessage({
                      id: "MENU.DASHBOARD_PLANS_SALES.PENDING",
                    })}
                  </p>
                </div>
              </td>
              <td>
                <div>
                  <p className="fw-bold text-hover-primary fs-6">10</p>
                </div>
              </td>
              <td>
                <div>
                  <p className="fw-bold text-hover-primary fs-6">
                    {intl.formatMessage({
                      id: "MENU.DASHBOARD_PLANS_SALES.ENTERED_TODAY",
                    })}
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="col-4 card text-center justify-content-center align-items-center table-responsive ms-5 me-3">
        <label className="fw-bold text-hover-primary fs-1">
          {intl.formatMessage({
            id: "MENU.DASHBOARD_PLANS_SALES.VISITOR",
          })}
        </label>
        <table className="table table-striped">
          <thead className="text-center border-bottom border-white">
            <tr>
              <th scope="col">
                <div>
                  <h3 className="fw-bold text-hover-primary fs-12">
                    {intl.formatMessage({
                      id: "MENU.DASHBOARD_PLANS_SALES.PHOTO",
                    })}
                  </h3>
                </div>
              </th>
              <th scope="col">
                <div>
                  <h3 className="fw-bold text-hover-primary fs-12">
                    {intl.formatMessage({
                      id: "MENU.DASHBOARD_PLANS_SALES.NAME",
                    })}
                  </h3>
                </div>
              </th>
              <th scope="col">
                <div>
                  <h3 className="fw-bold text-hover-primary fs-5">
                    {intl.formatMessage({
                      id: "MENU.DASHBOARD_PLANS_SALES.QTD_ACCESS",
                    })}
                  </h3>
                </div>
              </th>
              <th scope="col">
                <div>
                  <h3 className="fw-bold text-hover-primary fs-12">
                    {intl.formatMessage({
                      id: "MENU.DASHBOARD_PLANS_SALES.HOUR",
                    })}
                  </h3>
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="text-center justify-content-center align-items-center align-baseline">
            <tr>
              <td>
                <span className="svg-icon svg-icon-danger">
                  <img
                    id="imgUsersStudent"
                    className="w-40px"
                    src="/media/avatars/300-7.jpg"
                    alt="users"
                  />
                </span>
              </td>
              <td>
                <div>
                  <p className="fw-bold text-hover-primary fs-6">Rodrigo</p>
                </div>
              </td>
              <td>
                <div>
                  <h3 className="fw-bold text-hover-primary fs-6">2</h3>
                </div>
              </td>
              <td>
                <div>
                  <p className="fw-bold text-hover-primary fs-6">10:54 AM</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export { ListUsersSessionVisitor };
